/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import AddDialog from './AddDialog/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/AddAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<div
  data-testid="AddAction.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 size="medium"
 text="Add new"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'AddDialog/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'AddDialog/Content'))}
/>
</div>
<AddDialog
  viewPath={`${viewPath}/AddDialog`}
/>
{children}
</React.Fragment>)
}